import React from 'react';
import Icon from 'common/components/elements/icons'
import PropTypes from 'prop-types';
import './style.scss'
import { ChatMessageState } from 'admin/views/multi-access';
import cx from 'classnames';

const MultiAccessSameSettings = ({ title, state, data, contentType, isMobile, description, showPrerelease, showDownload, videoType, showNewStyles, showPercentage, type }) => {
   const isMedia = 'video' === contentType || 'photoset' === contentType || contentType === 'store'
   const isChat = 'chat' === contentType;
   const isCustomPage = 'custom_page' === contentType;
   const isLivestrea = 'live_stream' === contentType;

   return (
      <div className={ `flex mt-6 first-of-type:mt-4 justify-between gap-3  multi-access-init-state w-full pl-2` }>
         <span
            // notranslate-content-title
            className={ `text-sm font-medium text-major w-[160px] notranslate` }
            dangerouslySetInnerHTML={ { __html: title } }
         />
         <div
            className={ cx({
               'flex flex-col gap-1': true,
               'w-1/2 items-start': contentType !== 'chat',
               'ml-1 sm:w-[240px] sm:min-w-[240px] w-[62%] min-w-[62%]': contentType === 'chat',
            }) }
         >
            <div className='flex items-center'>
               <div
                  style={ {
                     minWidth: '24px',
                  } }
                  className={ `h-6 w-6 flex items-center justify-center mr-2 bg-${ state.color }-12 rounded-full` }>
                  <Icon name={ state.icon } size='base' color={ state.color } />
               </div>
               <span className={ `font-medium  text-major text-sm` }>{description || state.text}</span>
            </div>
            {
               contentType !== 'mass_message' &&
               <div className='flex flex-col ml-8'>
                  {
                     state.hasChildren && isMedia && (
                        <MediaAccess
                           data={ data }
                           contentType={ contentType }
                           isMobile={ isMobile }
                           showPrerelease={ showPrerelease }
                           showDownload={ showDownload }
                           videoType={ videoType }
                           showPercentage={ showPercentage }
                           type={ type }
                        />
                     )
                  }
                  {
                     state.hasChildren && isChat && (
                        <ChatMessageState
                           data={ data }
                        />
                     )
                  }
                  {
                     state.hasChildren && state.children && isCustomPage && (
                        state.children
                     )
                  }
                  {
                     state.hasChildren && isLivestrea && (
                        <LivestreaAccess
                           data={ data }
                           type={ type }

                        />
                     )
                  }
               </div>
            }
         </div>
      </div>
   )
}

const MediaAccess = ({ data, contentType, isMobile, showPrerelease, showDownload, videoType, showPercentage, type }) => {
   if('not_available' === data.type) {}
   if('hidden' === data.type) return null;
   const typePrefix = `for_${ data.type }`;
   let price = data[`download_price_${ typePrefix }`];
   let isFree = data[`download_is_free_${ typePrefix }`];
   let isAvailable = data[`download_available_${ typePrefix }`];
   let isAvailablePreRelease = false;
   let pricePreRelease = null;
   if(showPrerelease) {
      isAvailablePreRelease = data[`pre_release_available_${ typePrefix }`];
      pricePreRelease = data[`pre_release_price_${ typePrefix }`];
   }
   let downloadText = '';
   if(showDownload) {
      downloadText = 'No download';
      if(isAvailable){
         downloadText =  isFree ? 'Can download' : `Download for ${ price } USD`;
         if('locked' === data.type) {
            downloadText = isFree ? `${ downloadText } after unlock` : `Download after unlock for ${ price } USD`;
         }
      }

   }
   let mediatext = 'view';
   if('video' === contentType) {
      mediatext = 'video' === videoType ? 'stream' : 'watch'
   }
   let streamText = ''
   if(contentType !== 'store') {
      streamText = `Can ${ mediatext }`;

   }
   if('locked' === data.type){
      streamText = `Unlock for ${ data.unlock_price } USD`;
      if(contentType === 'store' && data?.cancelled_pay_more_to_unlock && showPercentage) {
         streamText = `Canceled pay ${ data?.cancelled_pay_more_to_unlock_percentage }% more`
      }
   }

   return (
      <div className='access-secondInfo flex flex-col text-secondary panel-description'>
         {
            'not_available' === data.type && contentType !== 'store' && ['expired', 'guest', 'all_others'].includes(type) && (
               <span> {
                  'video' === contentType ? 'Full video for members only' : 'Photoset for members only'
               }</span>
            )
         }
         {
            'not_available' !== data.type && streamText !== '' && (
               <span>{streamText} {!isMobile && showDownload ? '•' : <br />} {downloadText}</span>
            )
         }
         {
            isAvailablePreRelease && (pricePreRelease || 0 === +pricePreRelease) && (
               <span>Prerelease for {0 === +pricePreRelease ? 'free' : `${ pricePreRelease } USD`}</span>
            )
         }
      </div>
   )
}
const LivestreaAccess = ({ data, type }) => {
   if('not_available' === data.type) {}
   if('hidden' === data.type) return null;

   let streamText = 'Can watch';
   if('locked' === data.type){
      streamText = `Unlock for ${ data.unlock_price } USD`;
   }

   return (
      <div className='access-secondInfo flex flex-col text-secondary panel-description'>
         {
            'not_available' !== data.type && (
               <span>{streamText}</span>
            )
         }
         {
            'not_available' === data.type  && ['expired', 'guest', 'all_others'].includes(type) && (
               <span>Stream for members only</span>
            )
         }
      </div>
   )
}


MultiAccessSameSettings.propTypes = {
   showNewStyles: PropTypes.bool,
   title: PropTypes.string,
   state: PropTypes.object,
   data: PropTypes.object,
   contentType: PropTypes.string,
   description: PropTypes.string,
   isMobile: PropTypes.bool,
   showPrerelease: PropTypes.bool,
   showDownload: PropTypes.bool,
   videoType: PropTypes.string,
   type: PropTypes.string,
   showPercentage: PropTypes.bool,
};
MediaAccess.propTypes = {
   data: PropTypes.object,
   contentType: PropTypes.string,
   isMobile: PropTypes.bool,
   showPrerelease: PropTypes.bool,
   showDownload: PropTypes.bool,
   videoType: PropTypes.string,
   type: PropTypes.string,
   showPercentage: PropTypes.bool,
};
LivestreaAccess.propTypes = {
   data: PropTypes.object,
   type: PropTypes.string,

};

MultiAccessSameSettings.defaultProps = {
   contentType: 'chat',
   value: 'free',
   showPercentage: false,
};

MediaAccess.defaultProps = {
   data: {},
   showPercentage: false,
};

export default MultiAccessSameSettings
